type TagIntent = "positive" | "warning" | "negative" | "grayscale";

const IMPORT_STATUS_INTENT_MAP: Record<string, TagIntent> = {
  integrated: "positive",
  accepted: "warning",
  matching: "negative",
  refused: "negative",
  cancelled: "grayscale",
};
const DEFAULT_INTENT: TagIntent = "grayscale";

export const fromImportStatusToIntent = (importStatus: string): TagIntent => {
  return IMPORT_STATUS_INTENT_MAP[importStatus] || DEFAULT_INTENT;
};

// Where to fetch the Emission Factors aka "referential" for each import type is not straightforward
// see /bolo/app/services/data_registry_service.rb and /bolo/app/models/import_deposit.rb
const IMPORT_TYPE_REFERENTIAL_MAP: Record<string, string> = {
  downstream_deliveries_no_distance: "freight_transports", // DownstreamDelivery - transport_modes
  upstream_deliveries_no_distance: "freight_transports", // UpstreamDelivery - transport_modes
  downstream_deliveries_with_distance: "freight_transports", // DownstreamDelivery - transport_modes
  upstream_deliveries_with_distance: "freight_transports", // UpstreamDelivery - transport_modes
  vehicles: "passenger_transports_vehicle_fleet", // Vehicle - vehicles
  furniture_items: "items_public", // FurnitureItem - items
  products: "materials_public", // Product - materials
  materials: "materials_public", // Product - materials
  waste: "industrial_waste", // Waste - waste_types
  trips: "passenger_transports_commute", // Trip - transports
  websites: "cloud_providers", // Website - hosting_providers
  industrial_equipments: "industrial_equipments", // IndustrialEquipment - industrial_equipments
  tools: "", // Tool - TechCategory -- Not possible to do matchings + it does not come from data-registery, it's an ad hoc table in bolo
  services: "services", // Service - services
  offices: "energy_mixes_france", // Office - electricity_providers
};

export const fromImportTypeToReferentialName = (
  importType: string
): string | null => {
  return IMPORT_TYPE_REFERENTIAL_MAP[importType];
};

export const NB_MATCHINGS_PER_PAGE = 50;
